import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaLinhasSms } from "@/components/agenda/agenda-linhas-sms";

export const Route = createFileRoute("/agenda/linhas-sms")({
  component: () => (
    <AgendaShell>
      <AgendaLinhasSms />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Linhas & SMS — Agenda — GPS Drive" }] }),
});
